import { render } from "./AssignmentEditModal.vue?vue&type=template&id=3a2e8430&scoped=true"
import script from "./AssignmentEditModal.vue?vue&type=script&lang=js"
export * from "./AssignmentEditModal.vue?vue&type=script&lang=js"

import "./AssignmentEditModal.vue?vue&type=style&index=0&id=3a2e8430&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2e8430"]])

export default __exports__